import React from 'react';



type Props = {
	children: React.ReactNode,
};



const ConnectedInlineTextParts: React.FC<Props> = (props) => {
	const {
		children,
	} = props;

	return (
		<div className="connected-inline-text">
			{React.Children.map(
				children,
				(child) => {
					if (!child) {
						return null;
					}

					return (
						<div className="connected-inline-text__part">
							{child}
						</div>
					);
				},
			)}
		</div>
	);
};



export default ConnectedInlineTextParts;
